import React from 'react'
import { Container, Typography, Skeleton, } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Link as RouterLink,} from 'react-router-dom'
import DOMPurify from 'dompurify';  
import axios from 'axios'
import { useQuery } from '@tanstack/react-query'

import CustomButton from '@components/button/customButton'
import FeaturedTabs from './featuredTabs'

import { UserApiEndpoints } from '@configuration/apiEndpoints'

import PaperBackground from '@assets/image/paper-background.png'

import NoFeaturedIcon from '@assets/image/no-featured.png'

import "./featured.css";

const TabContentComponent = ({item, t}) => {

  const sanitizedContent = DOMPurify.sanitize(item ? item?.[`content${t('param')}`] : ``, {
    ADD_TAGS: ["iframe"], // Add iframe to the list of allowed tags
    ADD_ATTR: ["src", "width", "height", "allowfullscreen", "frameborder"] // Specify allowed attributes
  });

  return (
    <div 
      className='content-card'
      style={{
        backgroundImage: `url(${PaperBackground})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <Typography className='title'>{item && item[`header${t('param')}`]}</Typography>
      <Typography className='description'>{item && item[`tagline${t('param')}`]}</Typography>
      <div
        className="rich-text-content-featured"
        dangerouslySetInnerHTML={{ __html: sanitizedContent }}
      />
      {
        item?.isOpen && 
        <>
        {/* <Typography className='bottom-description'>{t('support-page.donateInstruction')}</Typography> */}
        {
        item?.isRedirect ? 
        <CustomButton component={RouterLink} to={item?.redirectLink}>{item[`buttonName${t('paramCap')}`]}</CustomButton>
        :
        <CustomButton component={RouterLink} to={`/featured/${item?.featureDonationGuid}`}>{t('featured-page.iSupport')}</CustomButton>
        }
        </>
      }
    </div>
  )
}

export default function Featured() {
  const { t } = useTranslation()

  const { isFetching, error, data, isError } = useQuery({
    queryKey: ['getFeaturedDonation'],
    queryFn: () =>
      axios.get(UserApiEndpoints.getFeaturedDonation, { requiresAuth: false }),
    initialData: [],
    select: (res) => {
      const data = res?.data || []
      return data
    },
  })

  const isEmpty = data.length === 0;
  
  return (
    <Container className='featured' maxWidth="md">
      <div>
        {isEmpty ?
          (isFetching || isError) ?
          <div style={{height: 'calc(100vh - 200px)'}}>
            <Skeleton animation={!isError && 'pulse'} variant="rounded" height={"100%"} style={{borderRadius: '10px'}}/>
          </div>
          :
          <div style={{height: 'calc(100vh - 200px)', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
            <img src={NoFeaturedIcon} style={{width: 175}} alt='No Featured'/>
            <Typography textAlign={'center'} fontSize={20} fontWeight={600} mt={'30px'} mb={'15px'}>{t('featured-page.noFeaturedDonation')}</Typography>
            <Typography textAlign={'center'} fontSize={14}>{t('featured-page.noFeaturedDonationDesc')}</Typography>
          </div>
        :
        <FeaturedTabs
          tabs={data.map((item) => ({
            label: item[`header${t('param')}`],
            value: item?.featureDonationGuid,
            component: <TabContentComponent item={item} t={t} />,
          }))}
        />
        
        }
      </div>
    </Container>
  )
}
